import {DestroyRef, Injectable} from '@angular/core';
import {Company} from "../../domain/company/company";
import {StorageNames} from "../../constants/storage-names.provider";
import {SessionStorageService} from "../storage/session-storage.service";
import {CompanyRepository} from "../../domain/company/company.barrel";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {Observable, Subject} from "rxjs";
import {LocalStorageService} from "../storage/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  companiesSubject = new Subject<Company[]>();
  private selectedCompanySource: Subject<string> = new Subject<string>();
  selectedCompany$ = this.selectedCompanySource.asObservable();



  constructor(private storageService: LocalStorageService, private companyRepository: CompanyRepository, private destroyRef: DestroyRef) {
  }

  getSelectedCompany(): Company | undefined {
    const selectedCompanyId = this.storageService.getItem(StorageNames.SelectedCompany);
    const companies = this.getCompanies();
    if (selectedCompanyId && companies) {
      return companies.find(company => company.id === selectedCompanyId);
    }
    return undefined;
  }

  getCompanies(): Company[] | null {
    return this.storageService.getItem(StorageNames.Companies);
  }

  hasCompany(): boolean {
    const companies = this.getCompanies();
    return companies ? companies.length > 0 : false;
  }

  loadCompanies(): Observable<Company[]> {
    const companiesObs = this.companiesSubject.asObservable();
    this.companyRepository
      .getFromRestApi()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (companies) => {
          this.storageService.setItem(StorageNames.Companies, companies);
          this.companiesSubject.next(companies);
          this.companiesSubject.complete();
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error fetching companies', error);
          if (error.status == HttpStatusCode.UnprocessableEntity) {
            this.companiesSubject.next([]);
          }
        }
      });
    return companiesObs;
  }


  setSelectedCompany(companyId: string) {
    this.storageService.setItem(StorageNames.SelectedCompany, companyId);
    this.selectedCompanySource.next(companyId);
  }
}
